import { Assets } from '@/pages/assets/AssetColumns';
import { Beacons } from '@/pages/beacons/BeaconColumns';
import { Billings } from '@/pages/billings/BillingsColumns';
import * as XLSX from 'xlsx';

export const exportAssetsToExcel = (data: Assets[], filename: any) => {

    const aoaData = [
        [
            'Customer Name',
            'Product Name',
            'Technician Name',
            'Beacon Cid',
            'Registration',
            'Client Name',
            'LoanId',
            'Status'
        ],
        ...data.map(obj => [
            obj.customer_name,
            obj.product_name,
            obj.technician_name,
            obj.beacon_cid,
            obj.registration,
            obj.client_name,
            obj.loan_id,
            obj.status === 1 ? 'Installed' : 'Not Installed'
        ])
    ];
    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.aoa_to_sheet(aoaData);

    XLSX.utils.book_append_sheet(workbook, worksheet, 'sheet');
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

    const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${filename}.xlsx`;
    a.click();
    URL.revokeObjectURL(url);
};

export const exportBillingsToExcel = (data: Billings[], filename: any) => {
    const aoaData = [
        [
            'assetId',
            'Client Name',
            'Customer Name',
            'Loan Id',
            'Registration',
            'Created At',
            'Updated At',
            'beacon Cid',
            'Billing Date',
            
        ],
        ...data.map(obj => [
            obj.asset_id ? obj.asset_id : "",
            obj.client_name,
            obj.customer_name,
            obj.loan_id,
            obj.registration,
            obj.created_at,
            obj.updated_at,
            obj.beacon,
            obj.billing_date ? obj.billing_date : ""
        ])
    ];
    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.aoa_to_sheet(aoaData);

    XLSX.utils.book_append_sheet(workbook, worksheet, 'sheet');
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

    const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${filename}.xlsx`;
    a.click();

    // Clean up
    URL.revokeObjectURL(url);
}

export const exportBeaconsToExcel = (data: Beacons[], filename: any) => {
    const aoaData = [
        [
            'id',
            'Beacon Store',
            'Beacon Type',
            'Beacon Cid',
            'TagNo',
            'Config Status',
            'Install Status',
            'Created At',
            'Updated At'
        ],
        ...data.map(obj => [
            obj.id,
            obj.beacon_store_name,
            obj.beacon_type_name,
            obj.cid,
            obj.tag_no,
            obj.config_status === 1 ? "Configured" : "Not Configured",
            obj.install_status === 1 ? "Installed" : "Not Installed",
            obj.created_at,
            obj.updated_at,
        ])
    ];
    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.aoa_to_sheet(aoaData);

    XLSX.utils.book_append_sheet(workbook, worksheet, 'sheet');
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

    const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${filename}.xlsx`;
    a.click();

    // Clean up
    URL.revokeObjectURL(url);
};

export const exportFailedUploadBeaconsToExcel = (data: any, filename: any) => {
    const aoaData = [
        [
            "beaconTypeId",
            "cid",
            "uuid",
            "tag_no"
        ],
        ...data.map((obj: any) => [
            obj.beaconTypeId,
            obj.cid,
            obj.uuid,
            obj.tag_no,
        ])
    ];
    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.aoa_to_sheet(aoaData);

    XLSX.utils.book_append_sheet(workbook, worksheet, 'sheet');
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

    const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${filename}.xlsx`;
    a.click();
    URL.revokeObjectURL(url);
}
export const exportFailedBeaconsDisableToExcel = (data: any, filename: any) => {
    const aoaData = [
        [
            "cid"
        ],
        ...data.map((obj: any) => [
            obj.cid
        ])
    ];
    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.aoa_to_sheet(aoaData);

    XLSX.utils.book_append_sheet(workbook, worksheet, 'sheet');
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

    const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${filename}.xlsx`;
    a.click();
    URL.revokeObjectURL(url);
}

export const exportBilledBeaconToExcel = (data: any, filename: any) => {
    const aoaData = [
        [
            "beacon",
            "status",
        ],
        ...data.map((obj: any) => [
            obj.beacon,
            obj.status,
        ])
    ];
    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.aoa_to_sheet(aoaData);

    XLSX.utils.book_append_sheet(workbook, worksheet, 'sheet');
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

    const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${filename}.xlsx`;
    a.click();
    URL.revokeObjectURL(url);
}


